import React from "react";
import { formatDate } from "../../utils/formatDate ";
import { useTranslation } from "react-i18next";
import UAEDirhamIcon from "../../utils/UAEDirhamIcon";
import { OrderStatus } from "../../../enum/orderStatus";

function OrderElement({ onClick, order, name }: any) {
  const { id, price, note, created_at, num_order, status } = order;
  const formattedDate = formatDate(created_at);
  const { t } = useTranslation();

  return (
    <div
      className="border p-4 rounded-lg shadow-md flex justify-between items-center cursor-pointer hover:shadow-lg"
      onClick={() => onClick(order)}
    >
      <div>
        <h3 className="text-lg font-bold">
          {t("gloabl.order")} #{num_order}
        </h3>
        <p className="text-sm flex items-center gap-1">
          <span className="font-bold">{t("gloabl.value")} : </span>
          <span dir="ltr" className="flex items-center gap-1">
            <UAEDirhamIcon className="w-3 h-3" />
            {price}
          </span>
        </p>
        <p className="text-sm  truncate">
          <span className="font-bold"> {t("gloabl.Notes")} : </span>{" "}
          {note || t("gloabl.noNotes")}
        </p>
        <p className="text-sm  truncate">
          <span className="font-bold"> {t("gloabl.name")} : </span>{" "}
          {order.customer_name || "___"}
        </p>
        <p className="text-sm  truncate">
          <span className="font-bold"> {t("contact.phone")} : </span>{" "}
          <span dir="ltr">{order.customer_phone || "___"}</span>
        </p>
        <p className="text-sm">
          <span className="font-bold">{t("gloabl.date")} : </span>
          {formattedDate}
        </p>
      </div>
      <div
        className={`px-3 py-2 rounded-full text-sm font-medium border ${getStatusColor(
          status
        )}`}
      >
        {t(`orderStatus.${status}`)}
      </div>
    </div>
  );
}

export default OrderElement;
export const getStatusColor = (status: string) => {
  switch (status) {
    case OrderStatus.pending:
      return "bg-yellow-100 text-yellow-800 border-yellow-200";
    case OrderStatus.processing:
      return "bg-blue-100 text-blue-800 border-blue-200";
    case OrderStatus.completed:
      return "bg-green-100 text-green-800 border-green-200";
    case OrderStatus.canseled:
      return "bg-red-100 text-red-800 border-red-200";
    default:
      return "bg-gray-100 text-gray-800 border-gray-200";
  }
};
